import { ApiService } from 'pf-frontend-common/src/service/api/service';

import { ApiEndpointService } from 'common/service/api-endpoint/service';

import { AgentLeadStore } from './store';

export function AgentLeadStoreFactory(): AgentLeadStore {
  return new AgentLeadStore(ApiService(), ApiEndpointService());
}
